export default __webpack_public_path__ + "static/media/Icons_Plus.0f39b192.svg";